import { matchPath } from "react-router-dom";

export type ChapterMatch = { action: "run" | "advance" | "rewind"; index: number } | { action: "none" };

type Route = string | string[];

export interface ChapterRoute {
  route: Route;
  when?: (pathname: string) => boolean;
}

export const chapterRoutes = (route: Route): string[] => (Array.isArray(route) ? route : [route]);

export const chapterMatches = (route: Route, pathname: string) =>
  chapterRoutes(route).some((r) => matchPath(r, pathname) !== null);

/** Which chapter the current route calls for: the current one (run), the next
 *  one (advance), the previous one (rewind — the user stepped back a page), or
 *  none (they wandered off; wait). Never more than one step in either
 *  direction. */
export function resolveChapter(
  chapters: readonly ChapterRoute[],
  pathname: string,
  current: number,
): ChapterMatch {
  const hit = (i: number) =>
    i >= 0 &&
    i < chapters.length &&
    chapterMatches(chapters[i].route, pathname) &&
    (chapters[i].when?.(pathname) ?? true);
  if (hit(current)) return { action: "run", index: current };
  if (hit(current + 1)) return { action: "advance", index: current + 1 };
  // Chapter 0 is the welcome card, shown by the start logic, not the demo.
  if (current - 1 >= 1 && hit(current - 1)) return { action: "rewind", index: current - 1 };
  return { action: "none" };
}
